/* Mon Beau Bon Bœuf — animations & interactions partagées (port de la maquette).
   Réveils au scroll (data-reveal), boutons magnétiques (.cta-magnet),
   barres de défilement personnalisées des rails (.rail-scroll). */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Réveils + magnétisme (GSAP, dégradation propre sans lib) ── */
  function initMotion() {
    if (reduce || typeof gsap === 'undefined') return;
    if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);
    function build() {
      gsap.utils.toArray('[data-reveal]').forEach(function (el) {
        gsap.from(el, { autoAlpha: 0, y: 28, duration: 0.9, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
      });
    }
    if (document.visibilityState === 'visible') build();
    else document.addEventListener('visibilitychange', function onVis() {
      if (document.visibilityState === 'visible') { document.removeEventListener('visibilitychange', onVis); build(); }
    });

    document.querySelectorAll('.cta-magnet').forEach(function (btn) {
      var strength = 6;
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        gsap.to(btn, { x: ((e.clientX - r.left - r.width / 2) / r.width) * strength, y: ((e.clientY - r.top - r.height / 2) / r.height) * strength, duration: 0.4, ease: 'expo.out' });
      });
      btn.addEventListener('pointerleave', function () { gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'expo.out' }); });
    });
  }

  /* ── Barre de défilement toujours visible pour les rails horizontaux ── */
  function initRailBars() {
    document.querySelectorAll('.rail-scroll').forEach(function (rail) {
      if (rail.dataset.railInit) { if (rail.__railUpdate) rail.__railUpdate(); return; }
      if (rail.scrollWidth <= rail.clientWidth + 2) return;
      rail.dataset.railInit = '1';
      var wrap = document.createElement('div');
      wrap.className = rail.dataset.railpad ? 'max-w-[1440px] mx-auto px-6 lg:px-10 mt-3' : 'mt-3';
      var bar = document.createElement('div'); bar.className = 'rail-track';
      var thumb = document.createElement('span'); bar.appendChild(thumb);
      wrap.appendChild(bar);
      rail.insertAdjacentElement('afterend', wrap);
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var tw = Math.max((rail.clientWidth / rail.scrollWidth) * 100, 12);
        thumb.style.width = tw + '%';
        thumb.style.left = (max > 0 ? (rail.scrollLeft / max) : 0) * (100 - tw) + '%';
      }
      rail.__railUpdate = update;
      update();
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }
  window.mbbRailBars = initRailBars;

  /* ── Ombre du header au scroll ── */
  function initHeaderShadow() {
    var header = document.getElementById('siteHeader');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('mbb-hdr-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Liens externes : toujours dans un nouvel onglet ──
     Dans l'aperçu de l'éditeur de thème, la page vit dans un cadre : Facebook et
     Instagram refusent d'y être chargés (« ERR_BLOCKED_BY_RESPONSE »). On force
     l'ouverture d'un vrai onglet dès qu'on est encadré. */
  function initExternalLinks() {
    var framed = false;
    try { framed = window.top !== window.self; } catch (e) { framed = true; }
    if (!framed) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[target="_blank"][href^="http"]');
      if (!a) return;
      e.preventDefault();
      window.open(a.href, '_blank', 'noopener');
    });
  }

  function init() { initMotion(); initRailBars(); initHeaderShadow(); initExternalLinks(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
